import React, { useMemo } from 'react';
import { useAssessment } from '../../contexts/AssessmentContext';

export default function DevResultsSanity() {
	const { results } = useAssessment();
	const data = useMemo(() => {
		if (results) return results;
		try {
			const stored = localStorage.getItem('assessmentResults');
			return stored ? JSON.parse(stored) : null;
		} catch (_) { return null; }
	}, [results]);

	if (!data) {
		return (
			<div style={{ maxWidth: 900, margin: '2rem auto', padding: '0 1rem' }}>
				<h2>Dev Results Sanity</h2>
				<p>No results found. Complete the assessment to view sanity output.</p>
			</div>
		);
	}

	const { preferenceScores = {}, domainScores = {}, timestamp } = data;
	const topElements = Object.values(preferenceScores)
		.sort((a, b) => (b.score - a.score))
		.slice(0, 12);
	const sortedDomains = Object.entries(domainScores).sort((a, b) => b[1] - a[1]);

	return (
		<div style={{ maxWidth: 1000, margin: '2rem auto', padding: '0 1rem' }}>
			<h2>Dev Results Sanity</h2>
			<p style={{ color: '#64748b' }}>Timestamp: {timestamp || 'n/a'}</p>

			<section style={{ marginTop: '1.5rem' }}>
				<h3>Top Elements (scores)</h3>
				<div style={{ overflowX: 'auto' }}>
					<table style={{ width: '100%', borderCollapse: 'collapse' }}>
						<thead>
							<tr>
								<th style={th}>#</th>
								<th style={th}>Element ID</th>
								<th style={th}>Score</th>
								<th style={th}>Forced Wins</th>
								<th style={th}>Forced Count</th>
							</tr>
						</thead>
						<tbody>
							{topElements.map((e, idx) => (
								<tr key={e.id}>
									<td style={td}>{idx + 1}</td>
									<td style={tdMono}>{e.id}</td>
									<td style={td}>{e.score}</td>
									<td style={td}>{e.forcedWins || 0}</td>
									<td style={td}>{e.forcedCount || 0}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</section>

			<section style={{ marginTop: '2rem' }}>
				<h3>Domain Scores</h3>
				<ul>
					{sortedDomains.map(([d, s]) => (
						<li key={d} style={{ fontFamily: 'monospace' }}>{d}: {s}</li>
					))}
				</ul>
			</section>

			<section style={{ marginTop: '2rem', color: '#64748b' }}>
				<p>Note: This internal view helps validate reverse-keying, ipsative (+1 to selected) and normalization before enabling the full user-facing results view.</p>
			</section>
		</div>
	);
}

const th = { textAlign: 'left', borderBottom: '1px solid #e2e8f0', padding: '8px' };
const td = { borderBottom: '1px solid #f1f5f9', padding: '8px' };
const tdMono = { ...td, fontFamily: 'monospace' };
